/*
  Legal pages. (1) Fills the [data-tou-var] placeholders from window.touVars, which snippets/legal-page-vars.liquid
  builds from Theme settings > Legal page variables. A missing value leaves the text or link already in the page.
  (2) Opens the collapsed <details> that contain a #hash target, and scrolls to it, so links into the policy work.
*/
(function () {
  var vars = window.touVars || {};

  function fillPlaceholders() {
    document.querySelectorAll('[data-tou-var]').forEach(function (el) {
      var key = el.getAttribute('data-tou-var');
      var val = vars[key];
      if (!val) return; // leave fallback text/href intact if not configured
      if (el.tagName === 'A') {
        el.href = key === 'CS_EMAIL' ? 'mailto:' + val : val;
        el.textContent = key === 'CS_EMAIL' ? val : el.textContent;
      } else {
        el.textContent = val;
      }
    });
  }

  function openAncestorDetails(hash) {
    if (!hash) return;
    var target = document.getElementById(hash.replace(/^#/, ''));
    if (!target) return;
    var el = target.parentElement;
    while (el && el !== document.body) {
      if (el.tagName === 'DETAILS') el.open = true;
      el = el.parentElement;
    }
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillPlaceholders);
  } else {
    fillPlaceholders();
  }

  if (window.location.hash) {
    setTimeout(function () {
      openAncestorDetails(window.location.hash);
    }, 50);
  }
  window.addEventListener('hashchange', function () {
    openAncestorDetails(window.location.hash);
  });
})();
